import React from 'react';
import { Printer } from 'lucide-react';
import { useTranslation } from '../../../../../contexts/I18nProvider';

export interface LabelPrintConfirmModalProps {
    isOpen: boolean;
    /** Ferdig formulert spørsmål med totalantallet i teksten. */
    message: string;
    onConfirm: () => void;
    onCancel: () => void;
}

/**
 * Bekreftelse før utskrift av mange etiketter (TW 36376868).
 *
 * Taket i antallsfeltet stopper det absurde; denne dialogen stopper det tankeløse —
 * «Linjeantall» + «Alle» som sender en rull etiketter til skriveren uten at noen
 * tok stilling til totalen. Totalantallet står derfor alltid i meldingsteksten.
 */
export const LabelPrintConfirmModal: React.FC<LabelPrintConfirmModalProps> = ({
    isOpen,
    message,
    onConfirm,
    onCancel
}) => {
    const { t } = useTranslation();
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
            <div className="bg-white rounded-lg shadow-xl max-w-md w-full">
                <div className="bg-blue-600 text-white px-6 py-4 rounded-t-lg">
                    <div className="flex items-center">
                        <Printer className="h-6 w-6 mr-3" />
                        <h3 className="text-lg font-semibold">
                            {t('warehouse.modules.receipt.labelPrint.confirmTitle', {}, 'Bekreft utskrift')}
                        </h3>
                    </div>
                </div>

                <div className="px-6 py-4">
                    <p className="text-gray-700 whitespace-pre-line">{message}</p>
                </div>

                <div className="px-6 py-4 bg-gray-50 rounded-b-lg flex justify-end gap-3">
                    <button
                        onClick={onCancel}
                        className="px-4 py-3 min-h-[44px] bg-gray-200 text-gray-700 rounded hover:bg-gray-300 transition-colors font-medium"
                    >
                        {t('common.buttons.cancel', {}, 'Avbryt')}
                    </button>
                    <button
                        onClick={onConfirm}
                        className="px-4 py-3 min-h-[44px] bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors font-medium"
                    >
                        {t('warehouse.modules.receipt.labelPrint.confirmPrint', {}, 'Skriv ut')}
                    </button>
                </div>
            </div>
        </div>
    );
};
